/* MALLIENA extras: rotating announcement bar, Christmas cutoff (US),
   tiered pack messages + savings in the cart drawer, limited-edition badge,
   DROP 01 (announcement, countdowns, landing + banner switch, listing reveal). */
(function(){
  var M=window.MALLIENA||{}, ROOT=M.rootUrl||'/';
  function $(s,r){return (r||document).querySelector(s);}
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}
  function money(c){var a=(c/100).toFixed(2).replace(/\.00$/,'');return (M.moneyFormat||'${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/,a.replace(/\B(?=(\d{3})+(?!\d))/g,','));}

  /* ---------- Drop config (times come from theme settings, UTC) ---------- */
  var D=M.drop||{};
  function T(s){var t=Date.parse(s||'');return isNaN(t)?0:t;}
  var OVR=(function(){var q=location.search.match(/[?&]drop_now=([^&]+)/);return q?T(decodeURIComponent(q[1])):0;})(), T0=Date.now();
  function now(){return OVR?OVR+(Date.now()-T0):Date.now();} // ?drop_now=ISO lets us preview future states
  var tTeaser=T(D.teaser), tOpen=T(D.open), tUntil=T(D.until);

  /* ---------- Christmas delivery cutoff (USA only, real deadline) ---------- */
  var XMAS={startMonth:10,startDay:1,cutMonth:11,cutDay:9,label:'DEC 9',short:'Dec 9'}; // Nov 1 -> Dec 9 (months are 0-based)
  var bar=$('[data-ann]'), country=bar?bar.getAttribute('data-country'):'';
  function xmasOn(){
    if(/[?&]xmas_test=1/.test(location.search)) return true;
    if(country!=='US') return false;
    var n=new Date(), y=n.getFullYear();
    return n>=new Date(y,XMAS.startMonth,XMAS.startDay) && n<=new Date(y,XMAS.cutMonth,XMAS.cutDay,23,59,59);
  }

  /* ---------- Rotating announcement bar ---------- */
  if(bar){
    if(xmasOn()){
      var x=document.createElement('span'); x.setAttribute('data-ann-msg','');
      x.textContent='ORDER BY '+XMAS.label+' FOR CHRISTMAS DELIVERY';
      bar.insertBefore(x,bar.firstChild);
    }
    var n0=now(), dm='', dh=D.url||'/pages/drop-01';
    if(tTeaser && n0>=tTeaser && n0<tOpen) dm='THE PACK · DROP 01 · NOV 5 · 3PM ET';
    else if(tOpen && n0>=tOpen && n0<tUntil){ dm='THE PACK · DROP 01 · OUT NOW'; dh='/collections/'+(D.col||'the-pack'); }
    if(dm){ var a=document.createElement('a'); a.setAttribute('data-ann-msg',''); a.href=dh; a.textContent=dm; bar.insertBefore(a,bar.firstChild); }
    var msgs=$$('[data-ann-msg]',bar), i=0;
    msgs.forEach(function(m,k){m.hidden=k!==0;});
    if(msgs.length>1 && !(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)){
      setInterval(function(){
        var cur=msgs[i]; cur.classList.add('ann-out');
        setTimeout(function(){cur.hidden=true;cur.classList.remove('ann-out');i=(i+1)%msgs.length;var nx=msgs[i];nx.classList.add('ann-out');nx.hidden=false;requestAnimationFrame(function(){requestAnimationFrame(function(){nx.classList.remove('ann-out');});});},350);
      },4000);
    }
  }

  /* ---------- Christmas note on the product page ---------- */
  var eta=$('.eta');
  if(eta && xmasOn()){
    var g=document.createElement('p'); g.className='xmas-note';
    g.innerHTML='&#127873; <b>Giving it as a gift?</b> Order by '+XMAS.short+' for Christmas delivery in the USA.';
    eta.parentNode.insertBefore(g,eta.nextSibling);
  }

  /* ---------- Limited edition badge (only for products tagged limited-edition) ---------- */
  function renderDrop(){
    var d=$('[data-drop]'), title=$('.pinfo__title'); if(!d||!title||$('.drop'))return;
    var ed=parseInt(d.getAttribute('data-edition'),10)||0, leftAttr=d.getAttribute('data-left'), left=leftAttr===''?null:parseInt(leftAttr,10);
    var p=document.createElement('p'); p.className='drop';
    var html='<span class="drop__tag">LIMITED EDITION'+(ed?' · '+ed+' PIECES':'')+'</span>';
    if(left!==null){
      if(left<=0) html+='<span class="drop__left">SOLD OUT · RETIRED</span>';
      else if(left<=25 || !ed) html+='<span class="drop__left">Only '+left+' left</span>';
      else html+='<span class="drop__left">'+left+' of '+ed+' left</span>';
    }
    p.innerHTML=html; title.parentNode.insertBefore(p,title.nextSibling);
  }
  renderDrop(); window.__mlnaDrop=renderDrop;

  /* ---------- DROP 01: listing reveal at launch ---------- */
  function revealCards(){ if(!tOpen||now()<tOpen) return false; $$('[data-launch]').forEach(function(c){c.classList.add('is-live');}); return true; }
  if(!revealCards() && tOpen && tOpen-now()<864e5){ setTimeout(revealCards, Math.max(0,tOpen-now())+500); }

  /* ---------- DROP 01: countdowns ---------- */
  function pad(n){return (n<10?'0':'')+n;}
  function runCd(el){
    var to=T(el.getAttribute('data-cd-to')); if(!to) return;
    var dd=$('[data-cd-d]',el),hh=$('[data-cd-h]',el),mm=$('[data-cd-m]',el),ss=$('[data-cd-s]',el), iv=0, done=false;
    function tick(){
      var ms=Math.max(0,to-now()), S=Math.floor(ms/1000);
      if(dd)dd.textContent=pad(Math.floor(S/86400)); if(hh)hh.textContent=pad(Math.floor(S%86400/3600));
      if(mm)mm.textContent=pad(Math.floor(S%3600/60)); if(ss)ss.textContent=pad(S%60);
      if(ms<=0 && !done){ done=true; if(iv)clearInterval(iv); el.dispatchEvent(new CustomEvent('cd:zero',{bubbles:true})); }
    }
    tick(); if(!done) iv=setInterval(tick,1000);
  }

  /* landing page: switch to the live shop when the countdown ends */
  var dl=$('[data-dl]');
  if(dl){
    dl.addEventListener('cd:zero',function(){
      if(dl.classList.contains('is-live')) return;
      if($('[data-dl-shop] .card',dl)){ dl.classList.add('is-live'); revealCards(); return; }
      dl.classList.add('is-live');
      if(!/[?&]t=/.test(location.search)) setTimeout(function(){ location.replace(location.pathname+'?t='+Date.now()); },15000);
    });
  }
  /* home banner: switch to "shop the drop" at launch */
  var db=$('[data-dban]');
  if(db){
    db.addEventListener('cd:zero',function(){ db.classList.add('is-live'); var a=$('[data-dban-link]',db); if(a) a.href=a.getAttribute('data-live-href'); });
  }
  $$('[data-cd-to]').forEach(runCd);

  /* ---------- Cart drawer: next-tier message + pack savings ---------- */
  var foot=$('[data-cd-foot]'), working=false, dirty=false;
  function reopenCart(){var t=document.createElement('button');t.type='button';t.setAttribute('data-open','cart');t.hidden=true;document.body.appendChild(t);t.click();t.remove();}
  function enhance(){
    if(!foot||working||$('[data-x-tier]',foot)||!foot.firstChild) return;
    working=true;
    fetch(ROOT+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
      if(!c.item_count||$('[data-x-tier]',foot)) return;
      var mark=document.createElement('span'); mark.setAttribute('data-x-tier',''); mark.hidden=true; foot.appendChild(mark);
      var n=c.item_count, P=M.pack||{};
      if(P.on){
        /* v10 pack: theme.js already shows the 1-hoodie nudge; here only a quiet confirmation at 2+ */
        if(n>=2){ var ok2=document.createElement('div'); ok2.className='tier tier--ok'; ok2.innerHTML='&#10003; <b>Pack of two unlocked.</b> '+(P.pct||15)+'% off your hoodies is applied below.'; foot.insertBefore(ok2,foot.firstChild); }
      }
      /* No bundle offer is active: the old $179 / $249 tier messages were removed with those discounts. */
      var saved=0, names=[];
      (c.cart_level_discount_applications||[]).forEach(function(d){saved+=d.total_allocated_amount||0;names.push(d.title);});
      if(saved>0){
        var sub=$('.ci__sub',foot);
        if(sub){var s=document.createElement('p');s.className='ci__sub ci__save';s.innerHTML='<span>'+names.join(' + ')+'</span><span>&minus;'+money(saved)+'</span>';sub.parentNode.insertBefore(s,sub);}
      }
    }).catch(function(){}).then(function(){working=false; if(dirty){dirty=false; if(!$('[data-x-tier]',foot)) setTimeout(enhance,0);}});
  }
  if(foot && 'MutationObserver' in window){
    new MutationObserver(function(){ if($('[data-x-tier]',foot)) return; if(working){dirty=true;return;} setTimeout(enhance,0); }).observe(foot,{childList:true});
    foot.addEventListener('click',function(e){
      var b=e.target.closest('[data-x-more]'); if(!b) return;
      b.disabled=true;
      fetch(ROOT+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:b.getAttribute('data-x-more'),quantity:parseInt(b.getAttribute('data-x-qty'),10)})})
        .then(function(){reopenCart();}).catch(function(){b.disabled=false;});
    });
  }
})();
